import React from 'react';

function HomePage() {
  return <div className="wrapper" />;
}

export default HomePage;
